import { EduacProvider } from '@/core/providers/eduac.provider';
import WboIndexedDBPersistenceProvider from './wbo-indexeddb-persistence-provider';
import WboLocalFilesystemPersistenceProvider from './wbo-local-filesystem-persistence-provider';
import WboPersistenceProvider from '../interfaces/wbo-persistence-provider.interface';

declare const window: any;

/**
 * This class is a Locator for a WboPersistenceProvider instance.
 * It defines which is the implementation available for WboPersistenceProvider.
 * 
 */
class WboPersistenceLocatorProviderClass {

    get isElectron() {
      return  window.electronVersions && 'electron' in window.electronVersions ;
    }

    get userId() {
      return EduacProvider.prototype.$vue.$store.state.AuthStore.user.userId;
    }

    public getInstance(boardName : string) : WboPersistenceProvider {
      const wboPersistenceProvider = this.isElectron ? 
        new WboLocalFilesystemPersistenceProvider(boardName, this.userId) :  
        new WboIndexedDBPersistenceProvider(boardName, this.userId);
      return wboPersistenceProvider;
    }

}

export const WboPersistenceLocatorProvider = new WboPersistenceLocatorProviderClass();
